const base = '/simulator-trainings'
const instructor = `${base}/instructor`
const student = `${base}/student`
const instructorLed = '/instructor-led'
const studentLed = '/student-led'

const routes = {
  root: base,
  instructor,
  instructorIL: `${instructor}${instructorLed}`,
  instructorSL: `${instructor}${studentLed}`,
  student,
  studentIL: `${student}${instructorLed}`,
  studentSL: `${student}${studentLed}`,
}

export default routes
